import { useEffect, useState } from 'react';

import { useLocation, matchPath } from 'react-router-dom';

import { routes } from 'constants/routes';

const SUB_DIV_SCROLL_PAGES = [routes.settings.review.reviewCycle];

export const matchSubDivScrollPageRoute = (pathname) => {
  for (const path of SUB_DIV_SCROLL_PAGES) {
    const match = matchPath(pathname, {
      path,
      exact: true,
    });

    if (match) {
      return path;
    }
  }

  return false;
};

// this is required because old page used higher div level scroll, where as new page uses sub div level scroll,
// so we need to set a CSS overflow value accordingly in HeaderAndContentContainer in App.js
// therefore this hook is used to identify if current page is new and using sub div level scroll, also if the specific flag is enabled
export const useIsSubDivScrollPage = () => {
  const [isSubDivScrollPage, setIsSubDivScrollPage] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const matchedPageRoute = matchSubDivScrollPageRoute(location.pathname);

    setIsSubDivScrollPage(!!matchedPageRoute);
  }, [location.pathname]);

  return isSubDivScrollPage;
};
